import { BaseService } from "./../base";
export class RegionService extends BaseService {
  static get entity() {
    return "region";
  }
  static get name() {
    return "region";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }

  static async getByCountryId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find/${id}`, this.name);
  }
}
